import icon from 'assets/img/icons/icon-warning.svg'

const SellPopupError = ({closePopup}) => {
  return (
    <div className='modal-window__wrapper' onClick={(e) => e.stopPropagation()}>
      <header className="modal-window__header">
        <img src={icon} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">Selling Declined!</h5>
        <p className="modal-window__info">Something went wrong.</p>
      </header>
      <footer className="modal-window__footer">
        <button className="modal-window__footer-submit" onClick={closePopup}>Done</button>
      </footer>
    </div>
  )
}

export default SellPopupError;
